import { render, staticRenderFns } from "./ViewBrand.vue?vue&type=template&id=111f038d"
import script from "./ViewBrand.vue?vue&type=script&lang=js"
export * from "./ViewBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports